module.exports = "<pre><code class=\"hljs html\"><span class=hljs-section>&lt;ultra-component&gt;</span><span class=hljs-section>&lt;/ultra-component&gt;</span>\n</code></pre>";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/default-example.md
 ** module id = 66
 ** module chunks = 1
 **/